export const ORDER_TYPE_INSTALLMENTS = 'installments';
export const NOOSA_SESSION_ID = 'NoosaSessionId';
export var NPG_APP_VER = "developer_machine";

//export var NPG_APP_VER = "developer_machine";
NPG_APP_VER = "npg_pre-prod_30ec5ba_1681824559505";
console.log ('NPG_APP_VER=' + NPG_APP_VER); 
